import {Component} from '@angular/core';
import {SessionService} from './core/session.service';
import {CacheService} from './core/cache.service';
import {LayoutService, RouteControlService} from 'phd-akita-session';
import {UiQuery} from './shared/state/ui.query';
import {filterNil} from '@datorama/akita';
import {tap} from 'rxjs/operators';
import {environment} from '../environments/environment';
import {NzMessageService} from 'ng-zorro-antd/message';
import {NzNotificationService} from 'ng-zorro-antd/notification';

@Component({
  selector: 'ims-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {

  error$;
  info$;

  // pre-load services when app starts
  constructor(cache: CacheService,
              sess: SessionService,
              layout: LayoutService,
              routeCtl: RouteControlService,
              private ui: UiQuery,
              private message: NzMessageService,
              private notification: NzNotificationService) {
    document.title = `TK-IMS [v${environment.version}]`;
    this.error$ = this.ui.select(u => u.errorMessage)
      .pipe(filterNil, tap(msg => {
        this.notification.blank('錯誤', msg.message, {nzDuration: 0});
      }));
    this.info$ = this.ui.select(u => u.infoMessage)
      .pipe(filterNil, tap(msg => this.message.info(msg.message)));
  }

}
